import { mergeClasses } from '@/utils';

import { FileX02Icon, Mail04Icon, SlashCircle02Icon, PlaneIcon } from '@/assets/icons';
import { Counter, GlassContainer } from '@/components/common';

interface IIntakeJobMetricsCard {
  className?: string;
  messagesRead: number;
  regulatoryNotifications: number;
  notRegulatoryNotifications: number;
  messagesFailed: number;
}

export const IntakeJobMetricsCard = ({
  className,
  messagesRead,
  regulatoryNotifications,
  notRegulatoryNotifications,
  messagesFailed,
}: IIntakeJobMetricsCard) => {
  return (
    <GlassContainer className={mergeClasses('flex flex-1 flex-col gap-4', className)}>
      <div className="text-h6 font-bold text-neutral-9">Job Metrics</div>
      <div className="flex gap-3">
        <Counter
          variant="vertical"
          label="Messages Read"
          value={messagesRead.toString()}
          icon={Mail04Icon}
          iconClassName="!border-primary-light !bg-primary-lighter !text-primary-base"
          className="!border-primary-lighter !bg-primary-lightest flex-1 max-w-none"
        />
        <Counter
          variant="vertical"
          label="Regulatory Notifications"
          value={regulatoryNotifications.toString()}
          icon={PlaneIcon}
          iconClassName="!border-cyan-light !bg-[linear-gradient(0deg,var(--color-opacity-light-50),var(--color-opacity-light-50)),linear-gradient(0deg,var(--color-cyan-lighter),var(--color-cyan-lighter))] !text-cyan-base"
          className="!border-cyan-lighter !bg-cyan-lightest flex-1 max-w-none"
        />
        <Counter
          variant="vertical"
          label="Not Regulatory"
          value={notRegulatoryNotifications.toString()}
          icon={FileX02Icon}
          iconClassName="!border-violet-light !bg-violet-lighter !text-violet-base"
          className="!border-violet-lighter !bg-violet-lightest flex-1 max-w-none"
        />
        <Counter
          variant="vertical"
          label="Failed"
          value={messagesFailed.toString()}
          icon={SlashCircle02Icon}
          iconClassName="!border-red-light !bg-[linear-gradient(0deg,var(--color-opacity-light-50),var(--color-opacity-light-50)),linear-gradient(0deg,var(--color-red-lighter),var(--color-red-lighter))] !text-red-base"
          className="border-red-lighter !bg-red-lightest flex-1 max-w-none"
        />
      </div>
    </GlassContainer>
  );
};
